import { render, staticRenderFns } from "./ccVideo.vue?vue&type=template&id=34065c2d&scoped=true&"
import script from "./ccVideo.vue?vue&type=script&lang=js&"
export * from "./ccVideo.vue?vue&type=script&lang=js&"
import style0 from "./ccVideo.vue?vue&type=style&index=0&id=34065c2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34065c2d",
  null
  
)

export default component.exports